// extracted by mini-css-extract-plugin
module.exports = {"productsSlider":"style_productsSlider__QonnN"};